export default __webpack_public_path__ + "static/media/condor_logo.ebba29ca.svg";